import { Form as FormComponent } from '@unform/web';
import styled from 'styled-components';

import { Button } from '../../../../components/Button';
import { InputText } from '../../../../components/InputText';
import { SeparateLabel } from '../../../../components/SeparateLabel';
import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  padding: 20px;
  margin-bottom: 32px;

  background-color: ${colors.primary}1a;
  border-left: 4px solid ${colors.primary};
  border-radius: ${radius.DEFAULT};

  p.tag {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    color: ${colors.primary};
    margin-bottom: 4px;
  }

  p.text {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.onSurface};
  }
`;

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled(SeparateLabel)`
  margin-top: 16px;

  span {
    color: ${colors.primary};
    font-weight: 700;
  }
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Input = styled(InputText)``;

export const Info = styled(TextInfo)`
  margin-bottom: 4px;
`;

export const ExistingUserTag = styled.p`
  display: flex;
  align-items: center;

  padding: 10px 14px;
  border-radius: ${radius.DEFAULT};
  background-color: ${colors.primary}1a;

  font-size: 12px;
  font-weight: 600;
  color: ${colors.primary};
`;

export const ContainerCheckboxBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 4px;

  label {
    font-size: 13px;
    line-height: 1.5;
    color: ${colors.onSurfaceVariant};

    a {
      color: ${colors.primary};
    }
  }
`;

export const ButtonSubmit = styled(Button)`
  margin-top: 16px;
`;

export const BackLink = styled.p`
  text-align: center;
  margin-top: 16px;
  font-size: 12px;
  color: ${colors.onSurfaceVariant};

  button {
    background: transparent;
    border: none;
    padding: 0;
    font-size: 12px;
    color: ${colors.primary};
    font-weight: 700;
    cursor: pointer;
  }
`;
